module.exports = __webpack_public_path__ + "img/fttt.9308d7e7.png";